'use es6';

import { useCallback, useMemo, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/components/View';
import debounce from 'transmute/debounce';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeSearchInput({
  onClear,
  onSearch,
  setSearchText,
  searchText
}) {
  const debouncedSearchRef = useRef(null);
  const debouncedSearch = useMemo(() => {
    return debounce(500, value => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        onClear();
      } else if (trimmedValue.length >= 3) {
        onSearch({
          query: trimmedValue,
          timestamp: Date.now()
        });
      } else {
        setSearchText(trimmedValue);
      }
    });
  }, [onClear, onSearch, setSearchText]);
  debouncedSearchRef.current = debouncedSearch;
  const handleSearchChange = useCallback(({
    target: {
      value
    }
  }) => debouncedSearchRef.current(value), []);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-field-default",
    padding: "300",
    children: /*#__PURE__*/_jsx(SearchInput, {
      onChange: handleSearchChange,
      defaultValue: searchText,
      use: "on-dark",
      "data-selenium-test": "callees-search-input"
    })
  });
}
CalleeSearchInput.propTypes = {
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
  searchText: PropTypes.string
};
export default /*#__PURE__*/memo(CalleeSearchInput);